<template>
  <div>

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">SNS 블록 관리</h4>
            <p class="card-title-desc">
              <code>적용 예시 페이지</code> : <a target="_blank" href="https://cdn0.mocoplex.com/editor/brandbooster_nextpaper_example2.html?ver=3">https://cdn0.mocoplex.com/editor/brandbooster_nextpaper_example2.html?ver=3</a>
              <br/>
              <code>예시 페이지 소스</code>
              <br/>
              <textarea v-model="html_source" readonly style="width:100%;height:250px;font-size:12px;border:1px solid #ddd;outline:none;resize:none;"></textarea>
            </p>

            <div class="d-grid py-3">
              <button @click="add_sns_block" type="button" class="btn btn-primary waves-effect waves-light">SNS 블록 추가 <i style="padding-left: 3px" class="fas fa-plus"></i></button>
            </div>
            <div v-for="(blockObj, blockIdx) in blockList" :key="blockObj.blockId" style="background-color:#eee;margin-top:30px;padding-bottom:20px;">
              <div style="padding:20px 10px;">
                <span>블록 이름: </span>
                <edit-text @change="patchBlockName(blockObj)" v-model="blockObj.blockName_edit"/>
                <div style="float:right;">
                  <span>디자인 스킨: </span>
                  <select v-model="blockObj.design_skin" @change="patchBlockOrder($event, blockObj.blockId)" style="padding:5px;font-size:.7875rem;">
                    <option value="skin1">스킨1</option>
                    <option value="skin2">스킨2</option>
                    <option value="skin3">스킨3</option>
                  </select>
                  <span>정렬 순서: </span>
                  <select v-model="blockObj.sortBy" @change="patchBlockOrder($event, blockObj.blockId)" style="padding:5px;font-size:.7875rem;">
                    <option value="like_count_desc">좋아요 많은 순서</option>
                    <option value="insert_date_asc">먼저 등록된 순서</option>
                    <option value="insert_date_desc">최근 등록된 순서</option>
                    <option value="ordinal_no">직접 지정 순서</option>
                  </select>
                  <button @click="postSnsBlockPiece(blockObj.blockId)" type="button" style="margin-left:10px" class="btn btn-primary btn-sm waves-effect waves-light">SNS URL 추가</button>
                  <button @click="delete_sns_block(blockObj.blockId, blockIdx)" type="button" style="margin-left: 10px" class="btn btn-danger btn-sm waves-effect waves-light">삭제</button>
                </div>
              </div>
              <div class="brandbooster-wrap" style="background-color:#fff;max-width:800px;margin:0 auto;">
                <div class="item-list">
                  <p v-if="!blockObj.pieceList.length" style="margin:0;padding:10px;">&#60;등록된 SNS 게시물이 없습니다&#62;</p>
                  <div v-else v-for="(pieceObj, pieceIdx) in blockObj.pieceList" :key="pieceObj.pieceId" class="item" @mouseover="pieceObj.mouseover = true" @mouseleave="pieceObj.mouseover = false">
                    <div class="item1">
                      <div class="item2">
                        <img v-if="pieceObj.videoUrl==null || pieceObj.videoUrl==''" :src="pieceObj.imageUrl"/>
                        <video v-else muted="" autoplay="" loop="">
                          <source :src="pieceObj.videoUrl" type="video/mp4">
                        </video>
                      </div>

                      <p class="stats_area">
                        <img class="like_icon" src="https://cdn0.mocoplex.com/editor/img/heart.png"/>
                        <span class="like_text" v-text="numberWithCommas(pieceObj.likeCount)"></span>
                        <img class="comment_icon" src="https://cdn0.mocoplex.com/editor/img/comment.png"/>
                        <span class="comment_text" v-text="numberWithCommas(pieceObj.commentCount)"></span>
                      </p>

                      <div v-show="pieceObj.mouseover" style="width:80%;height:80%;background-color:rgba(255,255,255,0.5);position:absolute;left:0;top:0;margin:10%;border-radius:10px;">
                        <div style="text-align:center;position:relative;padding-top:calc(50% - 20px)">
                          <svg @click="patch_snsblock_piece_order(pieceObj.pieceId, -1, blockObj.sortBy)" class="btn-piece" viewBox="0 0 24 24">
                            <path fill="#333" d="M20,9V15H12V19.84L4.16,12L12,4.16V9H20Z"></path>
                          </svg>
                          <svg @click="patch_snsblock_piece_order(pieceObj.pieceId, 1, blockObj.sortBy)" class="btn-piece" viewBox="0 0 24 24">
                            <path fill="#333" d="M4,15V9H12V4.16L19.84,12L12,19.84V15H4Z"></path>
                          </svg>
                          <svg @click="delete_snsblock_piece(pieceObj.pieceId, blockIdx, pieceIdx)" class="btn-piece" viewBox="0 0 24 24">
                            <path fill="#ff3d60" d="M19,4H15.5L14.5,3H9.5L8.5,4H5V6H19M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19Z"></path>
                          </svg>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>
              <div style="padding:10px;text-align:center;">
                <hr/>
                <p style="margin:10px 0 0;">
                  <span>브랜드부스터 스크립트 내용</span>
                  <span style="color:#aaa;font-size:12px;margin-left:5px;">(아래 텍스트를 복사하여 HTML의 원하는 위치에 붙여 넣으세요)</span>
                </p>
                <textarea v-model="blockObj.brandboosterScript" style="width:100%;max-width:800px;border:1px solid #aaa;height:140px;padding:5px 0;font-size:12px;resize:none;"></textarea>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div v-show="loading" style="position:fixed;left:0;top:0;width:100%;height:100vh;background-color:#ffffffaa;">
      <img src="https://cdn0.mocoplex.com/editor/img/loading.gif?v=1" style="position:fixed;left:calc(50vw - 25px);top:calc(50vh - 25px);width:50px;height:50px;"/>
    </div>

  </div>
</template>
<script>
import EditText from '@/components/form/EditText';
import {mapMutations, mapGetters} from 'vuex';
export default {
  components:{
    EditText,
  },
  computed:mapGetters({
    login: 'login', // 로그인 상태
  }),
  data: () => ({
    html_source:
        '<html>\n' +
        '    <body>\n\n' +
        '            <!-- 브랜드부스터 삽입 부분 1 -->\n' +
        '            <div class="brandbooster-wrap" block_id="8"></div>\n\n' +
        '            <!-- 브랜드부스터 삽입 부분 2 -->\n' +
        '            <div class="brandbooster-wrap" block_id="26"></div>\n\n' +
        '        <!-- 브랜드 부스터 스크립트 삽입, 브랜드부스터 UI를 여러개 삽입하더라도 이 스크립트는 한 번만 삽입 -->\n' +
        '        <script src="//cdn0.mocoplex.com/editor/js/brandbooster_nextpaper_example2.js?ver=3"><\/script>\n'+
        '    </body>\n'+
        '</html>',
    loading: false,
    pageName:'',
    pageList: [],
    meditor:false,
    blockList: [],
    favicon: {
      'youtube': 'https://www.youtube.com/s/desktop/f507fb37/img/favicon.ico',
      'instagram': 'https://www.instagram.com/static/images/ico/favicon.ico/36b3ee2d91ed.ico',
      'tiktok': 'https://lf16-tiktok-web.ttwstatic.com/obj/tiktok-web-common-sg/mtact/static/images/logo_144c91a.png',
    },
    brandboosterIframeStyle: "width:100%;",
  }),
  watch:{
    meditor:function () {
      if(this.meditor)
        this.$refs.editor.open()
      else
        this.$refs.editor.close()
    },
  },
  methods: {
    patchBlockName(blockObj){
      blockObj.blockName_edit = blockObj.blockName_edit.trim()
      // 값이 입력이 안되었다.
      if(!blockObj.blockName_edit){
        this.$eventBus.$emit('error', '이름을 입력해주세요')
        blockObj.blockName_edit = blockObj.blockName
        return
      }
      this.loading = true;
      this.$http
          .patch('/api_home/brandbooster/block', {
            blockId: blockObj.blockId,
            key: 'block_name',
            value: blockObj.blockName_edit
          })
          .then(obj=>{
            this.getBrandboosterBlocks();
            this.loading = false;
          })
          .catch(err=>{
            console.warn(err)
            if(err.response.data.error_message == 'ERR05, 기등록된 블록이 존재'){
              this.$eventBus.$emit('error', '이미 등록된 블록이 존재합니다.')
            }
          })
    },
    patchBlockOrder(event, blockId){
      this.$http
          .patch('/api_home/brandbooster/block', {
            blockId: blockId,
            key: 'sort_by',
            value: event.target.value
          })
          .then(obj=>{
            this.getBrandboosterBlocks();
          })
          .catch(err=>{
            console.warn(err)
            if(err.response.data.error_message == 'ERR05, 기등록된 블록이 존재'){
              this.$eventBus.$emit('error', '이미 등록된 블록이 존재합니다.')
            }
          })
    },
    getBrandboosterBlocks(){ // 페이지 리스트를 API 조회하여 화면상에 출력
      this.$http
          .get('/api_home/brandbooster/blocks')
          .then(obj=>{
            for(let i=0; i<obj.data.blockList.length; i++){
              obj.data.blockList[i].blockName_edit = obj.data.blockList[i].blockName
              obj.data.blockList[i].brandboosterScript = '' +
                  '<body>\n' +
                  '    <!-- 브랜드부스터 UI를 위치시킬 곳에 삽입 -->\n' +
                  '    <div class="brandbooster-wrap" block_id="' + obj.data.blockList[i].blockId + '"></div>\n' +
                  '\n' +
                  '    <!-- <body> 태그 마지막에 삽입, 브랜드부스터 UI를 여러개 삽입하더라도 이 스크립트는 한 번만 삽입 -->\n' +
                  '    <script src="//cdn0.mocoplex.com/editor/js/brandbooster_nextpaper_example2.js?ver=3"><\/script>\n' +
                  '</body>'
              for(let j=0; j<obj.data.blockList[i].pieceList.length; j++){
                obj.data.blockList[i].pieceList[j].mouseover = false;
              }
            }
            this.blockList = obj.data.blockList;
            this.$nextTick(this.myshopHomeResize)
          })
          .catch(err=>{console.warn(err.response);})
    },
    myshopHomeResize(){
      // 리사이징 대상 리스트별로 반복
      const imageList = document.querySelectorAll('.home-image-resize');
      for(let i=0; i<imageList.length; i++){

        // 한줄당 출력 할 이미지 개수
        let countPerLine = imageList[i].getAttribute('countPerLine')
        if(countPerLine == undefined) countPerLine = 4; // 미지정시 기본값 4

        // li padding 값
        let liPadding = imageList[i].getAttribute('liPadding')
        if(liPadding == undefined) liPadding = 1; // 미지정시 기본값 1px

        // 리사이징
        const liWidth = imageList[i].offsetWidth / countPerLine - (liPadding * 2);
        const liTags = imageList[i].querySelectorAll('ul.home-image-resize li')
        for(let i=0; i<liTags.length; i++){
          liTags[i].style.width = liWidth + 'px';
          liTags[i].style.height = liWidth + 'px';
          liTags[i].style.padding = liPadding + 'px';
        }
      }
    },
    copy(item) {
      // const url = item.fullUrl;
      const url = item.urlPrefix + item.pageUrl_edit;
      const el = document.createElement('textarea');
      el.value = url;
      el.setAttribute('readonly', '');
      el.style.position = 'absolute';
      el.style.left = '-9999px';
      document.body.appendChild(el);
      const selected =  document.getSelection().rangeCount > 0  ? document.getSelection().getRangeAt(0) : false;
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
      if (selected) {
        document.getSelection().removeAllRanges();
        document.getSelection().addRange(selected);
      }
      this.$eventBus.$emit('info', '주소가 복사되었습니다.')
    },
    add_sns_block(){ // 브랜드부스터
      let block_name = prompt('블록 이름을 입력해주세요.');
      if(!block_name) return; // 미입력시 취소
      if(!block_name.length){
        this.$eventBus.$emit('error', '블록 이름을 입력해주세요.')
        return;
      }
      this.$http
          .post('/api_home/brandbooster/sns_block', {block_name: block_name})
          .then(obj=>{
            this.getBrandboosterBlocks();
          })
          .catch(err=>{
            console.warn(err)
            if(err.response.data.error_message == 'ERR05, 기등록된 블록이 존재'){
              this.$eventBus.$emit('error', '이미 등록된 블록이 존재합니다.')
            }
          })
    },
    delete_sns_block(blockId, blockIdx){
      if(!confirm('정말 삭제하시겠습니까?')) return;
      this.$http
          .delete('/api_home/brandbooster/block', {data: {blockId: blockId}})
          .then(obj=>{
            this.blockList.splice(blockIdx, 1);
          })
          .catch(err=>{
            console.warn(err.response);
          });
    },
    getParameterByName(name, url){ // 브랜드부스터
      name = name.replace(/[\[\]]/g, '\\$&');
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
          results = regex.exec(url);
      if (!results) return null;
      if (!results[2]) return '';
      return decodeURIComponent(results[2].replace(/\+/g, ' '));
    },
    postSnsBlockPiece(blockId){
      let sns_url = prompt('[유튜브/인스타그램] url을 입력해주세요');
      if(!sns_url) return; // 미입력시 취소
      if( // 유튜브나 인스타그램이 아닌 경우 에러
          (
              sns_url.indexOf('youtube.com/watch') == -1
              && sns_url.indexOf('youtu.be/') == -1
          )
          &&
          (
              sns_url.indexOf('instagram.com/p/') == -1
              && sns_url.indexOf('instagram.com/tv/') == -1
              && sns_url.indexOf('instagram.com/reel/') == -1
          )
          && sns_url.indexOf('tiktok.com') == -1
      ){
        this.$eventBus.$emit('error', '올바른 URL이 아닙니다.')
        return;
      }
      let api_url;
      let api_data;
      if(sns_url.indexOf('instagram') != -1){
        api_url = '/api_home/brandbooster/block/piece-instagram'
        api_data = {instagram_url: sns_url, blockId: blockId}
      }else if(sns_url.indexOf('youtube') != -1){
        api_url = '/api_home/brandbooster/block/piece-youtube'
        api_data = {youtube_url: sns_url, blockId: blockId}
      }else if(sns_url.indexOf('tiktok') != -1){
        api_url = '/api_home/brandbooster/block/piece-tiktok'
        api_data = {tiktok_url: sns_url, blockId: blockId}
      }else{
        return;
      }
      this.loading = true;
      this.$http
          .post(api_url, api_data)
          .then(obj=>{
            this.getBrandboosterBlocks();
            this.loading = false;
          })
          .catch(err=>{
            console.warn(err)
            if(err.response.data != undefined && err.response.data.error_message == 'ERR05, 기등록된 블록이 존재'){
              this.$eventBus.$emit('error', '이미 등록된 블록이 존재합니다.')
            }
          })
    },
    numberWithCommas(x){
      if(x == null) x = 0
      if(x >= 100000) return (x/10000).toFixed(0) + '만'
      else if(x >= 10000) return (x/10000).toFixed(1) + '만'
      else if(x >= 1000) return (x/1000).toFixed(1) + '천'
      else return x;
    },
    delete_snsblock_piece(pieceId, blockIdx, pieceIdx){
      if(!confirm('정말 삭제하시겠습니까?')) return;
      this.$http
          .delete('/api_home/brandbooster/block/piece', {data: {pieceId: pieceId}})
          .then(obj=>{
            this.blockList[blockIdx].pieceList.splice(pieceIdx, 1);
          })
          .catch(err=>{
            console.warn(err.response);
          });
    },
    patch_snsblock_piece_order(pieceId, direction, sortBy){
      if(sortBy != 'ordinal_no'){
        alert('정렬 순서 설정이 \'직접 지정 순서\' 일 경우에만 변경 가능합니다.');
        return;
      }
      this.loading = true;
      this.$http
          .put('/api_home/brandbooster/block/piece/direction', {pieceId: pieceId, direction: direction})
          .then(obj=>{
            this.getBrandboosterBlocks();
            this.loading = false;
          })
          .catch(err=>{
            console.warn(err.response);
          });
    },
  },
  mounted: function() {
    this.$store.commit('nav_name','나의 페이지')
    this.$store.commit('page_name','페이지 설정')
    window.addEventListener('resize', this.myshopHomeResize);
    this.getBrandboosterBlocks(); // 브랜드부스터

  },
}
</script>
<style>
  .btn-piece{width:38px;height:38px;padding:1px;background-color:rgba(255,255,255,0.5);border-radius:5px;cursor:pointer;margin:1px;}
  .btn-piece:hover{background-color:rgba(255,255,255,1);}
  .selectbox {position:relative;width:120px;border:1px solid #999;z-index:1;display:inline-block;padding:0.31rem 0.5rem;font-size:.7875rem;border-radius:0.2rem;vertical-align:middle;background:#74788d;border:0;}
  .selectbox:before {content:"";position:absolute;top:50%;right:15px;width:0;height:0;margin-top:-1px;border-left:5px solid transparent;border-right:5px solid transparent;border-top:5px solid #333;}
  .selectbox label {position:absolute;top:1px;left:5px;padding:.4em .5em;color:#999;z-index:-1;font-weight:inherit;color:#eff2f7;}
  .selectbox select {width:100%;height:auto;line-height:normal;font-family:inherit;border:0;opacity:0;filter:alpha(opacity=0);-webkit-appearance:none;-moz-appearance:none;appearance:none;}

  .brandbooster-wrap{--column-count:4; --image-margin:7px; overflow:hidden;}
  .brandbooster-wrap .item-list{margin:calc(var(--image-margin) * -1) 0 0 calc(var(--image-margin) * -1);display:block;position:relative;box-sizing:border-box;font-size:0;}
  .brandbooster-wrap .item-list .item{width:calc((100% - (var(--column-count) * var(--image-margin))) / var(--column-count));margin:var(--image-margin) 0 0 var(--image-margin);font-size:13px;display:inline-block;}
  .brandbooster-wrap .item-list .item .item1{width:100%;padding-top:100%;position:relative;}
  .brandbooster-wrap .item-list .item .item1 .item2{position:absolute;top:0;left:0;bottom:0;right:0;overflow:hidden;}
  .brandbooster-wrap .item-list .item .item1 .item2 img{width:100%;height:100%;object-fit:cover;}
  .brandbooster-wrap .item-list .item .item1 .item2 video{width:100%;height:100%;object-fit:cover;}
  .brandbooster-wrap .item-list .item .item1 .stats_area{height:29px;position:absolute;bottom:7px;right:7px;margin:0px;padding:0px;background-color:#444444cc;color:white;border-radius:15px;box-sizing:border-box;overflow:hidden;max-width:28vw;text-overflow:ellipsis;white-space:nowrap;word-wrap:normal;text-align:center;}
  .brandbooster-wrap .item-list .item .item1 .stats_area .like_icon{vertical-align:middle;margin:7px 0;margin-left:12px;width:15px;}
  .brandbooster-wrap .item-list .item .item1 .stats_area .like_text{vertical-align:middle;margin:7px 0;margin-left:4px;font-size:12px;line-height:12px;}
  .brandbooster-wrap .item-list .item .item1 .stats_area .comment_icon{vertical-align:middle;margin:7px 0;margin-left:8px;width:15px;}
  .brandbooster-wrap .item-list .item .item1 .stats_area .comment_text{vertical-align:middle;margin:7px 0;margin-left:4px;margin-right:12px;font-size:12px;line-height:12px;}
  .brandbooster-wrap .area_view_more{text-align:center;padding-top:50px;}
  .brandbooster-wrap .area_view_more .btn_view_more{cursor:pointer;width:38px;}
</style>